import { render } from "./RegistroDatosAspirante.vue?vue&type=template&id=2a82c6f3"
import script from "./RegistroDatosAspirante.vue?vue&type=script&lang=js"
export * from "./RegistroDatosAspirante.vue?vue&type=script&lang=js"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__